export default __webpack_public_path__ + "static/media/39_1_2.190dd52d.png";